import type { StarterDataTransferObject } from '@mobi/api-types/racePage/types'
import type { IObservableStarter } from '../Model/Observables/IObservableStarter'
import ObservableRaceStarter from '../Model/Observables/ObservableRaceStarter'
import { BaseRaceCodeBuilder } from './BaseRaceCodeBuilder'

export default class RaceBuilder extends BaseRaceCodeBuilder {
  build(dto: StarterDataTransferObject): IObservableStarter {
    const model = super.addBaseInformation(
      new ObservableRaceStarter(),
      dto
    ) as ObservableRaceStarter
    model.template('race-starters-template')
    model.barrier(dto.Barrier)
    model.jockeyWeight(dto.JockeyWeight)
    model.tag('Race')

    return model
  }
}
